import { Data } from "../../utils/Data.js";
import { CategoryScale } from "chart.js";
import Chart from "chart.js/auto";

Chart.register(CategoryScale);

export const chartData = {
  labels: Data.map((data) => data.year),

  datasets: [
    {
      label: "CPU",
      data: Data.map((data) => data.userGain),
      backgroundColor: [
        "rgba(75,192,192,1)",
        "#ecf0f1",
        "#f0331a",
        "#f3ba2f",
        "#2111d0"
      ],
      borderColor: "black",
      borderWidth: 2
    },
    {
        label: "GPU",
        data: Data.map((data) => data.userGain),
        backgroundColor: [
            "rgba(75,192,12,1)",
            "#ecf",
            "#f0651a",
            "#f3bf",
            "#2a71d0"
        ],
        borderColor: "black",
        borderWidth: 2
      }
  ]
};
